/** Shared by ProjectFilesCard and ProjectNotesCard — both upload through the
 * same `file_list` / `file_type: 5` PATCH shape, so the size/extension limit
 * they validate against has to be the one place, not two copies that drift. */
const MAX_SIZE_MB = 50
const ALLOWED_FILE_EXTENSIONS = [
  "png",
  "jpeg",
  "jpg",
  "pdf",
  "mp4",
  "mov",
  "webm",
  "doc",
  "docx"
]

export { ALLOWED_FILE_EXTENSIONS, MAX_SIZE_MB }
